import React, { useCallback } from "react";
import PropTypes from "prop-types";

/**
 * AccessCtrl component is used to render children only if roles matches with the user
 */

export function AccessCtrl(props) {
  const {
    children,
    roles = [],
    flowRoles = [],
    canAccess = () => false
  } = props;
  const hasPermission = useCallback(
    function checkPermission() {
      return roles.find((role) => flowRoles.includes(role)) || canAccess();
    },
    [roles, flowRoles, canAccess]
  );
  return hasPermission() ? <React.Fragment>{children}</React.Fragment> : null;
}

AccessCtrl.propTypes = {
  /**
   * Content that will be displayed inside access control if access is available
   */
  children: PropTypes.node.isRequired,
  /**
   * Array of roles for which the access should be given
   */
  roles: PropTypes.arrayOf(PropTypes.string),
  /**
   * Array of flow specific roles
   */
  flowRoles: PropTypes.arrayOf(PropTypes.string),
  /**
   * Function that return true/false on whether usesr hasaccess
   */
  canAccess: PropTypes.func
};

AccessCtrl.defaultProps = {
  roles: [],
  flowRoles: [],
  canAccess: () => false
};

export function hasAccess({
  roles = [],
  flowRoles = [],
  canAccess = () => false
}) {
  return roles.find((role) => flowRoles.includes(role)) || canAccess();
}
